import BgImage from '../../assets/repayment-channel/repayment-channel-bg.png'
import { Box, Typography, } from '@mui/material'
import SMAppRepaymentChannel from '../../containers/App-RepaymentChannel'
import SMAppHomeContactUs from '../../containers/App-Home/ContactUs'
import { useTranslation } from 'react-i18next'
import { ScreenWidthPort } from '../../ScreenWidthContext'
import { isTablet } from 'react-device-detect'

export const AppRepaymentChannelScreen: React.FC = () => {
    const { screenWidth } = ScreenWidthPort()

    const { t } = useTranslation()

    // ======================= VIEWS
    return (
        <>
        
        <Box sx={{ position: 'relative', 
                objectFit: 'cover',
                backgroundImage: `url(${BgImage})`,                
                backgroundSize: 'cover',    
                backgroundPosition: 'center',
                width: '100%',
                height: (screenWidth * 226 / 375),
            }}>

                <Box sx={{ position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.4)', justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                    <Typography fontSize={32} fontWeight={700} color={'#FBBF23'} textAlign={'center'}>
                        {t('t298')}
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignContent: 'center', alignItems: 'center', paddingTop: '8px'}}>
                        <Typography fontSize={14} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                            {t('t299')}
                        </Typography>
                        <Box sx={{ width: '1px', height: '20px', backgroundColor: '#FFFFFF', marginLeft: isTablet ? '15px' : '8px', marginRight: isTablet ? '15px' : '8px' }}></Box>
                        <Typography fontSize={14} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                            {t('t300')}
                        </Typography>
                        <Box sx={{ width: '1px', height: '20px', backgroundColor: '#FFFFFF', marginLeft: isTablet ? '15px' : '8px', marginRight: isTablet ? '15px' : '8px' }}></Box>
                        <Typography fontSize={14} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                            {t('t301')}
                        </Typography>
                    </Box>  
                </Box>
            </Box>

            <SMAppRepaymentChannel />
            <SMAppHomeContactUs />
        </>
    )
}

// ======================= EXPORT
export default AppRepaymentChannelScreen
